import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  // انسخ هذه البيانات من Firebase Console -> Project Settings -> General
 apiKey: "AIzaSyDxaZd2bSeE4lfeKj2b7YTZj-ybScvK74s",
  authDomain: "edu-notification-cd540.firebaseapp.com",
  projectId: "edu-notification-cd540",
  storageBucket: "edu-notification-cd540.firebasestorage.app",
  messagingSenderId: "53526825910",
  appId: "1:53526825910:web:39efd7056749e08343cf17",
  measurementId: "G-WJG524K510"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };